// frontend/src/pages/Organisation/TurnierEinstellungen.jsx
// TURNIER-EINSTELLUNGEN - Wertungssysteme konfigurieren (Japanese Style)

import React, { useState, useEffect } from 'react';
import './TurnierEinstellungen.css';

function TurnierEinstellungen() {
  const [einstellungen, setEinstellungen] = useState([]);
  const [turniere, setTurniere] = useState([]);
  const [selectedTurnier, setSelectedTurnier] = useState(null);
  const [turnierEinstellungen, setTurnierEinstellungen] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [activeTab, setActiveTab] = useState('global'); // 'global', 'turnier', 'zeitplan'
  const [editingItem, setEditingItem] = useState(null);

  // Zeitplan-Einstellungen
  const [zeitplanSettings, setZeitplanSettings] = useState({
    rings: 2,
    start_time: '09:00',
    pause_between_categories: 5,
    trennVorrundeFinale: false,
    trennAltersgruppen: false,
    disciplines: {
      'Formen':             { durationPerPerson: 3, breakAfter: 1, anzahlKampfrichter: 5, schlechtestenStreichen: true },
      'Selbstverteidigung': { durationPerPerson: 4, breakAfter: 1, anzahlKampfrichter: 3, anzahlTechniken: 5 },
      'Pointfighting':      { rounds: 2, roundDuration: 2, breakBetweenRounds: 1, verlängerungsDauer: 1, goldenPoint: true,  erholungszeit: 5,  breakAfter: 2,
                              finale:     { rounds: 3, roundDuration: 2, breakBetweenRounds: 1, verlängerungsDauer: 1, goldenPoint: true,  erholungszeit: 5  },
                              kids:       { rounds: 2, roundDuration: 1, breakBetweenRounds: 1, verlängerungsDauer: 1, goldenPoint: false, erholungszeit: 3  },
                              kids_finale:{ rounds: 2, roundDuration: 1, breakBetweenRounds: 1, verlängerungsDauer: 1, goldenPoint: true,  erholungszeit: 3  } },
      'Continous Fighting': { rounds: 2, roundDuration: 2, breakBetweenRounds: 1, verlängerungsDauer: 1, goldenPoint: false, erholungszeit: 8,  breakAfter: 2,
                              finale:     { rounds: 3, roundDuration: 2, breakBetweenRounds: 1, verlängerungsDauer: 1, goldenPoint: false, erholungszeit: 8  },
                              kids:       { rounds: 2, roundDuration: 1, breakBetweenRounds: 1, verlängerungsDauer: 1, goldenPoint: false, erholungszeit: 5  },
                              kids_finale:{ rounds: 2, roundDuration: 1, breakBetweenRounds: 1, verlängerungsDauer: 1, goldenPoint: true,  erholungszeit: 5  } },
      'Kickboxen':          { rounds: 2, roundDuration: 2, breakBetweenRounds: 1, verlängerungsDauer: 2, goldenPoint: false, erholungszeit: 10, breakAfter: 2,
                              finale:     { rounds: 3, roundDuration: 2, breakBetweenRounds: 1, verlängerungsDauer: 2, goldenPoint: false, erholungszeit: 10 },
                              kids:       { rounds: 2, roundDuration: 1, breakBetweenRounds: 1, verlängerungsDauer: 1, goldenPoint: false, erholungszeit: 5  },
                              kids_finale:{ rounds: 2, roundDuration: 1, breakBetweenRounds: 1, verlängerungsDauer: 1, goldenPoint: true,  erholungszeit: 5  } },
      'Vollkontakt':        { rounds: 2, roundDuration: 2, breakBetweenRounds: 1, verlängerungsDauer: 2, goldenPoint: false, erholungszeit: 10, breakAfter: 2,
                              finale:     { rounds: 3, roundDuration: 2, breakBetweenRounds: 1, verlängerungsDauer: 2, goldenPoint: false, erholungszeit: 10 },
                              kids:       { rounds: 2, roundDuration: 1, breakBetweenRounds: 1, verlängerungsDauer: 1, goldenPoint: false, erholungszeit: 5  },
                              kids_finale:{ rounds: 2, roundDuration: 1, breakBetweenRounds: 1, verlängerungsDauer: 1, goldenPoint: true,  erholungszeit: 5  } },
      'Freefight':          { rounds: 2, roundDuration: 2, breakBetweenRounds: 1, verlängerungsDauer: 2, goldenPoint: false, erholungszeit: 10, breakAfter: 2,
                              finale:     { rounds: 3, roundDuration: 2, breakBetweenRounds: 1, verlängerungsDauer: 2, goldenPoint: false, erholungszeit: 10 },
                              kids:       { rounds: 2, roundDuration: 1, breakBetweenRounds: 1, verlängerungsDauer: 1, goldenPoint: false, erholungszeit: 5  },
                              kids_finale:{ rounds: 2, roundDuration: 1, breakBetweenRounds: 1, verlängerungsDauer: 1, goldenPoint: true,  erholungszeit: 5  } },
      'Rumble':             { rounds: 2, roundDuration: 2, breakBetweenRounds: 1, verlängerungsDauer: 1, goldenPoint: true,  erholungszeit: 8,  breakAfter: 2,
                              finale:     { rounds: 3, roundDuration: 2, breakBetweenRounds: 1, verlängerungsDauer: 1, goldenPoint: true,  erholungszeit: 8  },
                              kids:       { rounds: 2, roundDuration: 1, breakBetweenRounds: 1, verlängerungsDauer: 1, goldenPoint: false, erholungszeit: 5  },
                              kids_finale:{ rounds: 2, roundDuration: 1, breakBetweenRounds: 1, verlängerungsDauer: 1, goldenPoint: true,  erholungszeit: 5  } },
      'Kumite':             { matchDauer: 3, verlängerungsDauer: 1, goldenPoint: true,  erholungszeit: 8, breakAfter: 2,
                              finale:     { matchDauer: 3, verlängerungsDauer: 2, goldenPoint: true,  erholungszeit: 10 },
                              kids:       { matchDauer: 2, verlängerungsDauer: 1, goldenPoint: false, erholungszeit: 5  },
                              kids_finale:{ matchDauer: 2, verlängerungsDauer: 1, goldenPoint: true,  erholungszeit: 5  } },
      'Grappling':          { matchDauer: 4, verlängerungsDauer: 2, goldenPoint: false, erholungszeit: 8, breakAfter: 2,
                              finale:     { matchDauer: 5, verlängerungsDauer: 2, goldenPoint: false, erholungszeit: 10 },
                              kids:       { matchDauer: 3, verlängerungsDauer: 1, goldenPoint: false, erholungszeit: 5  },
                              kids_finale:{ matchDauer: 3, verlängerungsDauer: 1, goldenPoint: false, erholungszeit: 5  } },
      'Bruchtest':          { durationPerPerson: 5, breakAfter: 2 },
      'Default':            { durationPerMatch: 5, breakAfter: 2 }
    }
  });
  const [zeitplanSource, setZeitplanSource] = useState('hardcoded');

  // Globale Vorlage für alle Kampfsport-Disziplinen (Rundenstruktur)
  const [kampfsportPreset, setKampfsportPreset] = useState({
    rounds: 2, roundDuration: 2, breakBetweenRounds: 1,
    verlängerungsDauer: 1, goldenPoint: false, erholungszeit: 8, breakAfter: 2
  });

  useEffect(() => {
    fetchData();
    fetchZeitplanSettings();
  }, []);

  useEffect(() => {
    if (selectedTurnier) {
      fetchTurnierEinstellungen(selectedTurnier.turnier_id);
      fetchZeitplanSettings(selectedTurnier.turnier_id);
    } else {
      fetchZeitplanSettings();
    }
  }, [selectedTurnier]);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem('token');

      // Globale Einstellungen laden
      const einstellungenRes = await fetch('/api/wertung/einstellungen', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const einstellungenData = await einstellungenRes.json();
      if (einstellungenData.success) {
        setEinstellungen(einstellungenData.data);
      }

      // Turniere laden
      const turniereRes = await fetch('/api/turniere', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const turniereData = await turniereRes.json();
      if (turniereData.data) {
        setTurniere(turniereData.data);
      }

      setLoading(false);
    } catch (err) {
      console.error('Fehler beim Laden:', err);
      setLoading(false);
    }
  };

  const fetchTurnierEinstellungen = async (turnierId) => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`/api/wertung/turnier/${turnierId}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) {
        setTurnierEinstellungen(data.data);
      }
    } catch (err) {
      console.error('Fehler beim Laden der Turnier-Einstellungen:', err);
    }
  };

  const fetchZeitplanSettings = async (turnierId = null) => {
    try {
      const token = localStorage.getItem('token');
      const url = turnierId
        ? `/api/schedule/zeitplan-einstellungen/${turnierId}`
        : '/api/schedule/zeitplan-einstellungen/default';

      const res = await fetch(url, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();

      if (data.success && data.data) {
        setZeitplanSettings({
          rings: data.data.rings || 2,
          start_time: data.data.start_time || '09:00',
          pause_between_categories: data.data.pause_between_categories || 5,
          disciplines: data.data.disciplines || {}
        });
        setZeitplanSource(data.source || 'loaded');
      }
    } catch (err) {
      console.error('Fehler beim Laden der Zeitplan-Einstellungen:', err);
    }
  };

  const handleSaveZeitplanSettings = async (isGlobal = false) => {
    setSaving(true);
    try {
      const token = localStorage.getItem('token');
      const url = isGlobal
        ? '/api/schedule/zeitplan-einstellungen/default'
        : `/api/schedule/zeitplan-einstellungen/${selectedTurnier?.turnier_id}`;

      const res = await fetch(url, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(zeitplanSettings)
      });

      const data = await res.json();
      if (data.success) {
        alert(isGlobal ? 'Standard-Einstellungen gespeichert!' : 'Turnier-Einstellungen gespeichert!');
      } else {
        alert('Fehler: ' + data.error);
      }
    } catch (err) {
      alert('Fehler beim Speichern: ' + err.message);
    } finally {
      setSaving(false);
    }
  };

  const handleResetZeitplanToDefault = async () => {
    if (!selectedTurnier) return;
    if (!window.confirm('Zeitplan-Einstellungen auf Standard zurücksetzen?')) return;

    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`/api/schedule/zeitplan-einstellungen/${selectedTurnier.turnier_id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });

      const data = await res.json();
      if (data.success) {
        await fetchZeitplanSettings();
        alert('Auf Standard zurückgesetzt!');
      }
    } catch (err) {
      alert('Fehler: ' + err.message);
    }
  };

  const updateDiscipline = (name, field, value) => {
    setZeitplanSettings(prev => ({
      ...prev,
      disciplines: {
        ...prev.disciplines,
        [name]: {
          ...prev.disciplines[name],
          [field]: parseInt(value) || 0
        }
      }
    }));
  };

  const applyKampfsportPreset = () => {
    const keys = ['Pointfighting', 'Continous Fighting', 'Kickboxen', 'Vollkontakt', 'Freefight', 'Rumble'];
    setZeitplanSettings(prev => ({
      ...prev,
      disciplines: {
        ...prev.disciplines,
        ...Object.fromEntries(keys.map(k => [k, {
          ...prev.disciplines[k],
          ...kampfsportPreset,
          // Sub-Einstellungen erhalten
          finale:      prev.disciplines[k]?.finale,
          kids:        prev.disciplines[k]?.kids,
          kids_finale: prev.disciplines[k]?.kids_finale
        }]))
      }
    }));
  };

  const updateDisciplineSub = (name, sub, field, value) => {
    setZeitplanSettings(prev => ({
      ...prev,
      disciplines: {
        ...prev.disciplines,
        [name]: {
          ...prev.disciplines[name],
          [sub]: {
            ...prev.disciplines[name]?.[sub],
            [field]: typeof value === 'boolean' ? value : (parseInt(value) || 0)
          }
        }
      }
    }));
  };

  const updateDisciplineBool = (name, field, value) => {
    setZeitplanSettings(prev => ({
      ...prev,
      disciplines: {
        ...prev.disciplines,
        [name]: { ...prev.disciplines[name], [field]: value }
      }
    }));
  };

  const handleSaveGlobal = async (item) => {
    setSaving(true);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`/api/wertung/einstellungen/${encodeURIComponent(item.division_type)}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(item)
      });
      const data = await res.json();
      if (data.success) {
        await fetchData();
        setEditingItem(null);
        alert('Einstellung gespeichert!');
      } else {
        alert('Fehler: ' + data.message);
      }
    } catch (err) {
      alert('Fehler beim Speichern: ' + err.message);
    } finally {
      setSaving(false);
    }
  };

  const handleSaveTurnier = async (item) => {
    if (!selectedTurnier) return;

    setSaving(true);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`/api/wertung/turnier/${selectedTurnier.turnier_id}/${encodeURIComponent(item.division_type)}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(item)
      });
      const data = await res.json();
      if (data.success) {
        await fetchTurnierEinstellungen(selectedTurnier.turnier_id);
        setEditingItem(null);
        alert('Turnier-Einstellung gespeichert!');
      } else {
        alert('Fehler: ' + data.message);
      }
    } catch (err) {
      alert('Fehler beim Speichern: ' + err.message);
    } finally {
      setSaving(false);
    }
  };

  const handleResetToDefault = async (divisionType) => {
    if (!selectedTurnier) return;
    if (!window.confirm(`"${divisionType}" auf Standard zurücksetzen?`)) return;

    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`/api/wertung/turnier/${selectedTurnier.turnier_id}/${encodeURIComponent(divisionType)}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) {
        await fetchTurnierEinstellungen(selectedTurnier.turnier_id);
        alert('Auf Standard zurückgesetzt!');
      }
    } catch (err) {
      alert('Fehler: ' + err.message);
    }
  };

  if (loading) {
    return (
      <div className="turnier-einstellungen-jp loading">
        <div className="loading-kanji-jp">⚙️</div>
        <p>Lade Einstellungen...</p>
      </div>
    );
  }

  return (
    <div className="turnier-einstellungen-jp">
      {/* Header - Japanese Style */}
      <div className="page-header-jp">
        <div className="header-title-jp">
          <span className="header-kanji">⚙️</span>
          <div className="header-text-jp">
            <h1>Turnier-Einstellungen</h1>
            <p>Wertungssysteme und Punktebereiche konfigurieren</p>
          </div>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="tab-nav-jp">
        <button
          className={`tab-btn-jp ${activeTab === 'global' ? 'active' : ''}`}
          onClick={() => setActiveTab('global')}
        >
          <span className="tab-icon">⚙️</span>
          Standard-Einstellungen
        </button>
        <button
          className={`tab-btn-jp ${activeTab === 'turnier' ? 'active' : ''}`}
          onClick={() => setActiveTab('turnier')}
        >
          <span className="tab-icon">🏆</span>
          Turnier-spezifisch
        </button>
        <button
          className={`tab-btn-jp ${activeTab === 'zeitplan' ? 'active' : ''}`}
          onClick={() => setActiveTab('zeitplan')}
        >
          <span className="tab-icon">📅</span>
          Zeitplan-Einstellungen
        </button>
      </div>

      {/* Global Settings Tab */}
      {activeTab === 'global' && (
        <div className="settings-container-jp">
          <div className="section-header-jp">
            <h2>🎯 Standard-Einstellungen (Dauereinstellungen)</h2>
            <p>Diese Einstellungen gelten für alle Turniere, sofern nicht überschrieben.</p>
          </div>

          <div className="settings-grid-jp">
            {/* Bracket-Kategorien */}
            <div className="settings-group-jp">
              <h3>⚔️ Bracket-Kategorien (K.O.-System)</h3>
              {einstellungen
                .filter(e => e.wertungs_system === 'bracket')
                .map(item => (
                  <SettingsCardJP
                    key={item.division_type}
                    item={item}
                    isEditing={editingItem === item.division_type}
                    onEdit={() => setEditingItem(item.division_type)}
                    onSave={handleSaveGlobal}
                    onCancel={() => setEditingItem(null)}
                    saving={saving}
                  />
                ))}
            </div>

            {/* Punkte-Kategorien */}
            <div className="settings-group-jp">
              <h3>📊 Punkte-Kategorien (Bewertung)</h3>
              {einstellungen
                .filter(e => e.wertungs_system === 'pool' || e.wertungs_system === 'punkte')
                .map(item => (
                  <SettingsCardJP
                    key={item.division_type}
                    item={item}
                    isEditing={editingItem === item.division_type}
                    onEdit={() => setEditingItem(item.division_type)}
                    onSave={handleSaveGlobal}
                    onCancel={() => setEditingItem(null)}
                    saving={saving}
                  />
                ))}
            </div>
          </div>
        </div>
      )}

      {/* Tournament-specific Tab */}
      {activeTab === 'turnier' && (
        <div className="settings-container-jp">
          <div className="section-header-jp">
            <h2>🏯 Turnier-spezifische Einstellungen</h2>
            <p>Überschreiben Sie die Standard-Einstellungen für ein bestimmtes Turnier.</p>
          </div>

          {/* Turnier Auswahl */}
          <div className="turnier-selector-jp">
            <label>Turnier auswählen:</label>
            <select
              value={selectedTurnier?.turnier_id || ''}
              onChange={(e) => {
                const turnier = turniere.find(t => t.turnier_id === parseInt(e.target.value));
                setSelectedTurnier(turnier);
              }}
            >
              <option value="">-- Turnier wählen --</option>
              {turniere.map(t => (
                <option key={t.turnier_id} value={t.turnier_id}>
                  {t.name} ({new Date(t.datum).toLocaleDateString('de-DE')})
                </option>
              ))}
            </select>
          </div>

          {selectedTurnier && (
            <div className="turnier-settings-jp">
              <h3>Einstellungen für: {selectedTurnier.name}</h3>

              <div className="settings-list-jp">
                {turnierEinstellungen.map(item => (
                  <TurnierSettingsRowJP
                    key={item.division_type}
                    item={item}
                    isEditing={editingItem === `turnier-${item.division_type}`}
                    onEdit={() => setEditingItem(`turnier-${item.division_type}`)}
                    onSave={handleSaveTurnier}
                    onCancel={() => setEditingItem(null)}
                    onReset={() => handleResetToDefault(item.division_type)}
                    saving={saving}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      )}

      {/* Zeitplan Settings Tab */}
      {activeTab === 'zeitplan' && (
        <div className="settings-container-jp">
          <div className="section-header-jp">
            <h2>📅 Zeitplan-Einstellungen</h2>
            <p>Konfigurieren Sie die Zeiten für die automatische Zeitplan-Generierung.</p>
          </div>

          {/* Turnier Auswahl für spezifische Einstellungen */}
          <div className="turnier-selector-jp">
            <label>Einstellungen für:</label>
            <select
              value={selectedTurnier?.turnier_id || 'global'}
              onChange={(e) => {
                if (e.target.value === 'global') {
                  setSelectedTurnier(null);
                  fetchZeitplanSettings();
                } else {
                  const turnier = turniere.find(t => t.turnier_id === parseInt(e.target.value));
                  setSelectedTurnier(turnier);
                }
              }}
            >
              <option value="global">Standard (Global)</option>
              {turniere.map(t => (
                <option key={t.turnier_id} value={t.turnier_id}>
                  {t.name} ({new Date(t.datum).toLocaleDateString('de-DE')})
                </option>
              ))}
            </select>
            {zeitplanSource === 'turnier' && (
              <span className="override-badge-jp">Turnier-spezifisch</span>
            )}
          </div>

          {/* Basis-Einstellungen */}
          <div className="zeitplan-settings-box">
            <h3>⚙️ Basis-Einstellungen</h3>
            <div className="zeitplan-settings-grid">
              <div className="form-group-jp">
                <label>Anzahl Ringe</label>
                <input
                  type="number"
                  min="1"
                  max="10"
                  value={zeitplanSettings.rings}
                  onChange={(e) => setZeitplanSettings({
                    ...zeitplanSettings,
                    rings: parseInt(e.target.value) || 2
                  })}
                />
              </div>

              <div className="form-group-jp">
                <label>Beginn</label>
                <input
                  type="time"
                  value={zeitplanSettings.start_time}
                  onChange={(e) => setZeitplanSettings({
                    ...zeitplanSettings,
                    start_time: e.target.value
                  })}
                />
              </div>

              <div className="form-group-jp">
                <label>Pause zwischen Kategorien (Min)</label>
                <input
                  type="number"
                  min="0"
                  max="30"
                  value={zeitplanSettings.pause_between_categories}
                  onChange={(e) => setZeitplanSettings({
                    ...zeitplanSettings,
                    pause_between_categories: parseInt(e.target.value) || 5
                  })}
                />
              </div>
            </div>
          </div>

          {/* Disziplin-Zeiten */}
          <div className="zeitplan-settings-box">
            <h3>🥋 Disziplin-Zeiten</h3>

            {/* ── Formen / Kata ─────────────────────────────────── */}
            <div className="discipline-group-header">Formen &amp; Kata</div>

            <DisziplinRow icon="🥋" label="Formen / Hyong / Tul">
              <Mini label="Pro Person" min={1} max={10}
                value={zeitplanSettings.disciplines?.['Formen']?.durationPerPerson ?? 3}
                onChange={v => updateDiscipline('Formen', 'durationPerPerson', v)} unit="Min" />
              <Mini label="Kampfrichter" min={1} max={7}
                value={zeitplanSettings.disciplines?.['Formen']?.anzahlKampfrichter ?? 5}
                onChange={v => updateDiscipline('Formen', 'anzahlKampfrichter', v)} />
              <MiniHinweis label="Streichwertung"
                text="Turnier bearbeiten → Modi" />
              <Mini label="Pause danach" min={0} max={10}
                value={zeitplanSettings.disciplines?.['Formen']?.breakAfter ?? 1}
                onChange={v => updateDiscipline('Formen', 'breakAfter', v)} unit="Min" />
            </DisziplinRow>

            <DisziplinRow icon="🛡️" label="Selbstverteidigung">
              <Mini label="Pro Auftritt" min={1} max={15}
                value={zeitplanSettings.disciplines?.['Selbstverteidigung']?.durationPerPerson ?? 4}
                onChange={v => updateDiscipline('Selbstverteidigung', 'durationPerPerson', v)} unit="Min" />
              <Mini label="Anz. Techniken" min={1} max={10}
                value={zeitplanSettings.disciplines?.['Selbstverteidigung']?.anzahlTechniken ?? 5}
                onChange={v => updateDiscipline('Selbstverteidigung', 'anzahlTechniken', v)} />
              <Mini label="Kampfrichter" min={1} max={7}
                value={zeitplanSettings.disciplines?.['Selbstverteidigung']?.anzahlKampfrichter ?? 3}
                onChange={v => updateDiscipline('Selbstverteidigung', 'anzahlKampfrichter', v)} />
              <Mini label="Pause danach" min={0} max={10}
                value={zeitplanSettings.disciplines?.['Selbstverteidigung']?.breakAfter ?? 1}
                onChange={v => updateDiscipline('Selbstverteidigung', 'breakAfter', v)} unit="Min" />
            </DisziplinRow>

            {/* ── Kampfsport mit Runden ─────────────────────────── */}
            <div className="discipline-group-header">Kampfsport (Rundenstruktur)</div>

            {/* Optionen */}
            <div className="kampfsport-options-bar">
              <label className="option-toggle">
                <input type="checkbox"
                  checked={!!zeitplanSettings.trennVorrundeFinale}
                  onChange={e => setZeitplanSettings(p => ({ ...p, trennVorrundeFinale: e.target.checked }))} />
                Vorrunde / Finale unterscheiden
              </label>
              <label className="option-toggle">
                <input type="checkbox"
                  checked={!!zeitplanSettings.trennAltersgruppen}
                  onChange={e => setZeitplanSettings(p => ({ ...p, trennAltersgruppen: e.target.checked }))} />
                Erwachsene / Kids trennen
              </label>
            </div>

            {/* Globale Vorlage */}
            <div className="kampfsport-preset-box">
              <span className="preset-label">Vorlage für alle:</span>
              <div className="preset-fields">
                <div className="dfield">
                  <span className="dfield__label">Runden</span>
                  <input className="dfield__input" type="number" min={1} max={5}
                    value={kampfsportPreset.rounds}
                    onChange={e => setKampfsportPreset(p => ({ ...p, rounds: parseInt(e.target.value) || 2 }))} />
                </div>
                <div className="dfield">
                  <span className="dfield__label">Rundend. (Min)</span>
                  <input className="dfield__input" type="number" min={1} max={5}
                    value={kampfsportPreset.roundDuration}
                    onChange={e => setKampfsportPreset(p => ({ ...p, roundDuration: parseInt(e.target.value) || 2 }))} />
                </div>
                <div className="dfield">
                  <span className="dfield__label">Rundenpause (Min)</span>
                  <input className="dfield__input" type="number" min={0} max={3}
                    value={kampfsportPreset.breakBetweenRounds}
                    onChange={e => setKampfsportPreset(p => ({ ...p, breakBetweenRounds: parseInt(e.target.value) || 1 }))} />
                </div>
                <div className="dfield">
                  <span className="dfield__label">Verlängerung (Min)</span>
                  <input className="dfield__input" type="number" min={0} max={5}
                    value={kampfsportPreset.verlängerungsDauer}
                    onChange={e => setKampfsportPreset(p => ({ ...p, verlängerungsDauer: parseInt(e.target.value) || 1 }))} />
                </div>
                <div className="dfield dfield--check">
                  <span className="dfield__label">Goldener Punkt</span>
                  <input type="checkbox" checked={kampfsportPreset.goldenPoint}
                    onChange={e => setKampfsportPreset(p => ({ ...p, goldenPoint: e.target.checked }))} />
                </div>
                <div className="dfield">
                  <span className="dfield__label">Erholungszeit (Min)</span>
                  <input className="dfield__input" type="number" min={0} max={30}
                    value={kampfsportPreset.erholungszeit}
                    onChange={e => setKampfsportPreset(p => ({ ...p, erholungszeit: parseInt(e.target.value) || 8 }))} />
                </div>
                <div className="dfield">
                  <span className="dfield__label">Pause danach (Min)</span>
                  <input className="dfield__input" type="number" min={0} max={10}
                    value={kampfsportPreset.breakAfter}
                    onChange={e => setKampfsportPreset(p => ({ ...p, breakAfter: parseInt(e.target.value) || 2 }))} />
                </div>
                <button className="preset-apply-btn" onClick={applyKampfsportPreset}>
                  Auf alle anwenden
                </button>
              </div>
            </div>

            {[
              { key: 'Pointfighting',      icon: '⚡', label: 'Pointfighting / Semi Contact' },
              { key: 'Continous Fighting', icon: '🔥', label: 'Continous Fighting / Light Contact' },
              { key: 'Kickboxen',          icon: '🥊', label: 'Kickboxen / Low Kick' },
              { key: 'Vollkontakt',        icon: '💥', label: 'Vollkontakt / K-1' },
              { key: 'Freefight',          icon: '👊', label: 'Freefight' },
              { key: 'Rumble',             icon: '🌪️', label: 'Rumble' },
            ].map(({ key, icon, label }) => {
              const disc = zeitplanSettings.disciplines?.[key] ?? {};
              const showFinale = !!zeitplanSettings.trennVorrundeFinale;
              const showKids   = !!zeitplanSettings.trennAltersgruppen;
              const renderRunden = (vals, sub, defaults) => (
                <>
                  <Mini label="Runden" min={1} max={5}
                    value={vals.rounds ?? defaults?.rounds ?? 2}
                    onChange={v => sub ? updateDisciplineSub(key, sub, 'rounds', v) : updateDiscipline(key, 'rounds', v)} />
                  <Mini label="Rundend. (Min)" min={1} max={5}
                    value={vals.roundDuration ?? defaults?.roundDuration ?? 2}
                    onChange={v => sub ? updateDisciplineSub(key, sub, 'roundDuration', v) : updateDiscipline(key, 'roundDuration', v)} />
                  <Mini label="Rundenpause (Min)" min={0} max={3}
                    value={vals.breakBetweenRounds ?? defaults?.breakBetweenRounds ?? 1}
                    onChange={v => sub ? updateDisciplineSub(key, sub, 'breakBetweenRounds', v) : updateDiscipline(key, 'breakBetweenRounds', v)} />
                  <Mini label="Verlängerung (Min)" min={0} max={5}
                    value={vals.verlängerungsDauer ?? defaults?.verlängerungsDauer ?? 1}
                    onChange={v => sub ? updateDisciplineSub(key, sub, 'verlängerungsDauer', v) : updateDiscipline(key, 'verlängerungsDauer', v)} />
                  <MiniCheck label="Goldener Punkt"
                    checked={!!(vals.goldenPoint ?? defaults?.goldenPoint ?? false)}
                    onChange={v => sub ? updateDisciplineSub(key, sub, 'goldenPoint', v) : updateDisciplineBool(key, 'goldenPoint', v)} />
                  <Mini label="Erholungszeit (Min)" min={0} max={30}
                    value={vals.erholungszeit ?? defaults?.erholungszeit ?? 8}
                    onChange={v => sub ? updateDisciplineSub(key, sub, 'erholungszeit', v) : updateDiscipline(key, 'erholungszeit', v)} />
                  {!sub && (
                    <Mini label="Pause danach (Min)" min={0} max={10}
                      value={disc.breakAfter ?? 2}
                      onChange={v => updateDiscipline(key, 'breakAfter', v)} />
                  )}
                </>
              );
              return (
                <div key={key} className={`diszi-block${(showFinale || showKids) ? ' diszi-block--expanded' : ''}`}>
                  <DisziplinRow icon={icon} label={label}
                    sublabel={(showFinale || showKids) ? (showKids ? 'Erwachsene · Vorrunde' : 'Vorrunde') : null}>
                    {renderRunden(disc, null, {})}
                  </DisziplinRow>
                  {showFinale && (
                    <DisziplinRow icon="" label="" sub sublabel={showKids ? 'Erwachsene · Finale' : 'Finale'}>
                      {renderRunden(disc.finale ?? {}, 'finale', disc)}
                    </DisziplinRow>
                  )}
                  {showKids && (
                    <DisziplinRow icon="" label="" sub sublabel="Kids · Vorrunde">
                      {renderRunden(disc.kids ?? {}, 'kids', disc)}
                    </DisziplinRow>
                  )}
                  {showFinale && showKids && (
                    <DisziplinRow icon="" label="" sub sublabel="Kids · Finale">
                      {renderRunden(disc.kids_finale ?? {}, 'kids_finale', disc.kids ?? disc)}
                    </DisziplinRow>
                  )}
                </div>
              );
            })}

            {/* ── Einzelkampf (keine Rundenstruktur) ───────────── */}
            <div className="discipline-group-header">Einzelkampf (keine Runden)</div>

            {[
              { key: 'Kumite',    icon: '🥷', label: 'Kumite' },
              { key: 'Grappling', icon: '🤼', label: 'Grappling / BJJ' },
            ].map(({ key, icon, label }) => {
              const disc = zeitplanSettings.disciplines?.[key] ?? {};
              const showFinale = !!zeitplanSettings.trennVorrundeFinale;
              const showKids   = !!zeitplanSettings.trennAltersgruppen;
              const renderEinzel = (vals, sub, defaults) => (
                <>
                  <Mini label="Kampfdauer (Min)" min={1} max={10}
                    value={vals.matchDauer ?? defaults?.matchDauer ?? 3}
                    onChange={v => sub ? updateDisciplineSub(key, sub, 'matchDauer', v) : updateDiscipline(key, 'matchDauer', v)} />
                  <Mini label="Verlängerung (Min)" min={0} max={5}
                    value={vals.verlängerungsDauer ?? defaults?.verlängerungsDauer ?? 1}
                    onChange={v => sub ? updateDisciplineSub(key, sub, 'verlängerungsDauer', v) : updateDiscipline(key, 'verlängerungsDauer', v)} />
                  <MiniCheck label="Goldener Punkt"
                    checked={!!(vals.goldenPoint ?? defaults?.goldenPoint ?? false)}
                    onChange={v => sub ? updateDisciplineSub(key, sub, 'goldenPoint', v) : updateDisciplineBool(key, 'goldenPoint', v)} />
                  <Mini label="Erholungszeit (Min)" min={0} max={30}
                    value={vals.erholungszeit ?? defaults?.erholungszeit ?? 8}
                    onChange={v => sub ? updateDisciplineSub(key, sub, 'erholungszeit', v) : updateDiscipline(key, 'erholungszeit', v)} />
                  {!sub && (
                    <Mini label="Pause danach (Min)" min={0} max={10}
                      value={disc.breakAfter ?? 2}
                      onChange={v => updateDiscipline(key, 'breakAfter', v)} />
                  )}
                </>
              );
              return (
              <div key={key} className={`diszi-block${(showFinale || showKids) ? ' diszi-block--expanded' : ''}`}>
                <DisziplinRow icon={icon} label={label}
                  sublabel={(showFinale || showKids) ? (showKids ? 'Erwachsene · Vorrunde' : 'Vorrunde') : null}>
                  {renderEinzel(disc, null, {})}
                </DisziplinRow>
                {showFinale && (
                  <DisziplinRow icon="" label="" sub sublabel={showKids ? 'Erwachsene · Finale' : 'Finale'}>
                    {renderEinzel(disc.finale ?? {}, 'finale', disc)}
                  </DisziplinRow>
                )}
                {showKids && (
                  <DisziplinRow icon="" label="" sub sublabel="Kids · Vorrunde">
                    {renderEinzel(disc.kids ?? {}, 'kids', disc)}
                  </DisziplinRow>
                )}
                {showFinale && showKids && (
                  <DisziplinRow icon="" label="" sub sublabel="Kids · Finale">
                    {renderEinzel(disc.kids_finale ?? {}, 'kids_finale', disc.kids ?? disc)}
                  </DisziplinRow>
                )}
              </div>
            );
            })}

            {/* ── Sonstige ──────────────────────────────────────── */}
            <div className="discipline-group-header">Sonstige</div>

            <DisziplinRow icon="🔨" label="Bruchtest">
              <Mini label="Pro Person" min={1} max={15}
                value={zeitplanSettings.disciplines?.['Bruchtest']?.durationPerPerson ?? 5}
                onChange={v => updateDiscipline('Bruchtest', 'durationPerPerson', v)} unit="Min" />
              <Mini label="Pause danach" min={0} max={10}
                value={zeitplanSettings.disciplines?.['Bruchtest']?.breakAfter ?? 2}
                onChange={v => updateDiscipline('Bruchtest', 'breakAfter', v)} unit="Min" />
            </DisziplinRow>
          </div>

          {/* Aktionen */}
          <div className="zeitplan-actions-box">
            <button
              className="btn-save-jp"
              onClick={() => handleSaveZeitplanSettings(!selectedTurnier)}
              disabled={saving}
            >
              {saving ? 'Speichern...' : (selectedTurnier ? 'Turnier-Einstellungen speichern' : 'Standard-Einstellungen speichern')}
            </button>

            {selectedTurnier && zeitplanSource === 'turnier' && (
              <button
                className="btn-reset-jp"
                onClick={handleResetZeitplanToDefault}
                disabled={saving}
              >
                Auf Standard zurücksetzen
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

// Settings Card Component für globale Einstellungen (Japanese Style)
function SettingsCardJP({ item, isEditing, onEdit, onSave, onCancel, saving }) {
  const [editData, setEditData] = useState({ ...item });

  useEffect(() => {
    setEditData({ ...item });
  }, [item, isEditing]);

  if (!isEditing) {
    return (
      <div className="settings-card-jp">
        <div className="card-header-jp">
          <span className="division-type-jp">{item.division_type}</span>
          <span className={`wertung-badge-jp ${item.wertungs_system}`}>
            {item.wertungs_system === 'bracket' ? 'K.O.' : 'Punkte'}
          </span>
        </div>

        {(item.wertungs_system === 'pool' || item.wertungs_system === 'punkte') && (
          <div className="punkte-info-jp">
            <div className="punkte-range-jp">
              <span>Farbgurte:</span>
              <strong>{item.punkte_min_farbgurt} - {item.punkte_max_farbgurt}</strong>
            </div>
            <div className="punkte-range-jp">
              <span>Schwarzgurte:</span>
              <strong>{item.punkte_min_schwarzgurt} - {item.punkte_max_schwarzgurt}</strong>
            </div>
            <div className="kampfrichter-info-jp">
              <span>Kampfrichter:</span>
              <strong>{item.anzahl_kampfrichter}</strong>
            </div>
          </div>
        )}

        <p className="beschreibung-jp">{item.beschreibung}</p>

        <button className="btn-edit-jp" onClick={onEdit}>
          Bearbeiten
        </button>
      </div>
    );
  }

  return (
    <div className="settings-card-jp editing">
      <div className="card-header-jp">
        <span className="division-type-jp">{editData.division_type}</span>
      </div>

      <div className="form-group-jp">
        <label>Wertungssystem:</label>
        <select
          value={editData.wertungs_system}
          onChange={(e) => setEditData({ ...editData, wertungs_system: e.target.value })}
        >
          <option value="bracket">Bracket (K.O.-System)</option>
          <option value="punkte">Punkte (Bewertung)</option>
        </select>
      </div>

      {(editData.wertungs_system === 'pool' || editData.wertungs_system === 'punkte') && (
        <>
          <div className="form-row-jp">
            <div className="form-group-jp">
              <label>Farbgurte Min:</label>
              <input
                type="number"
                step="0.5"
                value={editData.punkte_min_farbgurt}
                onChange={(e) => setEditData({ ...editData, punkte_min_farbgurt: parseFloat(e.target.value) })}
              />
            </div>
            <div className="form-group-jp">
              <label>Farbgurte Max:</label>
              <input
                type="number"
                step="0.5"
                value={editData.punkte_max_farbgurt}
                onChange={(e) => setEditData({ ...editData, punkte_max_farbgurt: parseFloat(e.target.value) })}
              />
            </div>
          </div>

          <div className="form-row-jp">
            <div className="form-group-jp">
              <label>Schwarzgurte Min:</label>
              <input
                type="number"
                step="0.5"
                value={editData.punkte_min_schwarzgurt}
                onChange={(e) => setEditData({ ...editData, punkte_min_schwarzgurt: parseFloat(e.target.value) })}
              />
            </div>
            <div className="form-group-jp">
              <label>Schwarzgurte Max:</label>
              <input
                type="number"
                step="0.5"
                value={editData.punkte_max_schwarzgurt}
                onChange={(e) => setEditData({ ...editData, punkte_max_schwarzgurt: parseFloat(e.target.value) })}
              />
            </div>
          </div>

          <div className="form-group-jp">
            <label>Anzahl Kampfrichter:</label>
            <input
              type="number"
              min="1"
              max="10"
              value={editData.anzahl_kampfrichter}
              onChange={(e) => setEditData({ ...editData, anzahl_kampfrichter: parseInt(e.target.value) })}
            />
          </div>
        </>
      )}

      <div className="form-group-jp">
        <label>Beschreibung:</label>
        <input
          type="text"
          value={editData.beschreibung || ''}
          onChange={(e) => setEditData({ ...editData, beschreibung: e.target.value })}
        />
      </div>

      <div className="card-actions-jp">
        <button className="btn-cancel-jp" onClick={onCancel} disabled={saving}>
          Abbrechen
        </button>
        <button className="btn-save-jp" onClick={() => onSave(editData)} disabled={saving}>
          {saving ? 'Speichern...' : 'Speichern'}
        </button>
      </div>
    </div>
  );
}

// Turnier Settings Row für turnierspezifische Überschreibungen (Japanese Style)
function TurnierSettingsRowJP({ item, isEditing, onEdit, onSave, onCancel, onReset, saving }) {
  const [editData, setEditData] = useState({ ...item });

  useEffect(() => {
    setEditData({ ...item });
  }, [item, isEditing]);

  if (!isEditing) {
    return (
      <div className={`turnier-row-jp ${item.ist_ueberschrieben ? 'overridden' : ''}`}>
        <div className="row-main-jp">
          <span className="division-type-jp">{item.division_type}</span>
          <span className={`wertung-badge-jp ${item.wertungs_system}`}>
            {item.wertungs_system === 'bracket' ? 'K.O.' : 'Punkte'}
          </span>
          {(item.wertungs_system === 'pool' || item.wertungs_system === 'punkte') && (
            <span className="punkte-preview-jp">
              Farbgurt: {item.punkte_min_farbgurt}-{item.punkte_max_farbgurt} |
              Schwarzgurt: {item.punkte_min_schwarzgurt}-{item.punkte_max_schwarzgurt}
            </span>
          )}
          {item.ist_ueberschrieben && (
            <span className="override-badge-jp">Angepasst</span>
          )}
        </div>
        <div className="row-actions-jp">
          <button className="btn-edit-jp" onClick={onEdit}>Anpassen</button>
          {item.ist_ueberschrieben && (
            <button className="btn-reset-jp" onClick={onReset}>Standard</button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="turnier-row-jp editing">
      <div className="edit-form-jp">
        <h4>{item.division_type}</h4>

        <div className="form-group-jp">
          <label>Wertungssystem:</label>
          <select
            value={editData.wertungs_system}
            onChange={(e) => setEditData({ ...editData, wertungs_system: e.target.value })}
          >
            <option value="bracket">Bracket (K.O.-System)</option>
            <option value="punkte">Punkte (Bewertung)</option>
          </select>
        </div>

        {(editData.wertungs_system === 'pool' || editData.wertungs_system === 'punkte') && (
          <div className="punkte-fields-jp">
            <div className="form-row-jp">
              <div className="form-group-jp">
                <label>Farbgurte:</label>
                <div className="range-inputs-jp">
                  <input
                    type="number"
                    step="0.5"
                    value={editData.punkte_min_farbgurt}
                    onChange={(e) => setEditData({ ...editData, punkte_min_farbgurt: parseFloat(e.target.value) })}
                  />
                  <span>bis</span>
                  <input
                    type="number"
                    step="0.5"
                    value={editData.punkte_max_farbgurt}
                    onChange={(e) => setEditData({ ...editData, punkte_max_farbgurt: parseFloat(e.target.value) })}
                  />
                </div>
              </div>
              <div className="form-group-jp">
                <label>Schwarzgurte:</label>
                <div className="range-inputs-jp">
                  <input
                    type="number"
                    step="0.5"
                    value={editData.punkte_min_schwarzgurt}
                    onChange={(e) => setEditData({ ...editData, punkte_min_schwarzgurt: parseFloat(e.target.value) })}
                  />
                  <span>bis</span>
                  <input
                    type="number"
                    step="0.5"
                    value={editData.punkte_max_schwarzgurt}
                    onChange={(e) => setEditData({ ...editData, punkte_max_schwarzgurt: parseFloat(e.target.value) })}
                  />
                </div>
              </div>
            </div>
            <div className="form-group-jp">
              <label>Kampfrichter:</label>
              <input
                type="number"
                min="1"
                max="10"
                value={editData.anzahl_kampfrichter}
                onChange={(e) => setEditData({ ...editData, anzahl_kampfrichter: parseInt(e.target.value) })}
                style={{ width: '80px' }}
              />
            </div>
          </div>
        )}

        <div className="edit-actions-jp">
          <button className="btn-cancel-jp" onClick={onCancel} disabled={saving}>
            Abbrechen
          </button>
          <button className="btn-save-jp" onClick={() => onSave(editData)} disabled={saving}>
            {saving ? 'Speichern...' : 'Speichern'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Zeitplan-Hilfskomponenten ────────────────────────────────────────────────
function DisziplinRow({ icon, label, sublabel, sub, children }) {
  return (
    <div className={`drow${sub ? ' drow--sub' : ''}`}>
      <div className="drow__name">
        {sub ? (
          <span className="drow__sublabel">{sublabel}</span>
        ) : (
          <div className="drow__name-inner">
            <div className="drow__name-row">
              {icon && <span className="drow__icon">{icon}</span>}
              <span>{label}</span>
            </div>
            {sublabel && <span className="drow__sublabel-inline">{sublabel}</span>}
          </div>
        )}
      </div>
      <div className="drow__fields">
        {children}
      </div>
    </div>
  );
}

function Mini({ label, value, onChange, min = 0, max = 99, unit }) {
  return (
    <div className="dfield">
      <span className="dfield__label">{unit ? `${label} (${unit})` : label}</span>
      <input
        className="dfield__input"
        type="number"
        min={min}
        max={max}
        value={value}
        onChange={e => onChange(e.target.value)}
      />
    </div>
  );
}

// Verweist auf eine Einstellung, die woanders getroffen wird. Der Schalter
// "Beste/Schlechteste streichen" stand frueher hier und kannte den
// Wertungsmodus des Turniers nicht — zwei Orte, dieselbe Entscheidung. Der
// gespeicherte Wert (disciplines.Formen.schlechtestenStreichen) bleibt in den
// Einstellungen stehen, wird aber nicht mehr gelesen.
function MiniHinweis({ label, text }) {
  return (
    <div className="dfield dfield--hinweis">
      <span className="dfield__label">{label}</span>
      <span className="dfield__hinweis">{text}</span>
    </div>
  );
}

function MiniCheck({ label, checked, onChange }) {
  return (
    <div className="dfield dfield--check">
      <span className="dfield__label">{label}</span>
      <input
        type="checkbox"
        checked={checked}
        onChange={e => onChange(e.target.checked)}
      />
    </div>
  );
}
// ─────────────────────────────────────────────────────────────────────────────

export default TurnierEinstellungen;
